var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76553 13.3656C7.6155 13.5156 7.41206 13.5998 7.19993 13.5998C6.98779 13.5998 6.78435 13.5156 6.63433 13.3656L1.83433 8.56559C1.68435 8.41557 1.6001 8.21212 1.6001 7.99999C1.6001 7.78786 1.68435 7.58441 1.83433 7.43439L6.63433 2.63439C6.78521 2.48866 6.98729 2.40803 7.19705 2.40985C7.4068 2.41167 7.60745 2.49581 7.75578 2.64414C7.90411 2.79246 7.98824 2.99311 7.99007 3.20287C7.99189 3.41263 7.91125 3.61471 7.76553 3.76559L4.33113 7.19999H13.5999C13.8121 7.19999 14.0156 7.28428 14.1656 7.4343C14.3156 7.58433 14.3999 7.78782 14.3999 7.99999C14.3999 8.21216 14.3156 8.41565 14.1656 8.56568C14.0156 8.7157 13.8121 8.79999 13.5999 8.79999H4.33113L7.76553 12.2344C7.9155 12.3844 7.99976 12.5879 7.99976 12.8C7.99976 13.0121 7.9155 13.2156 7.76553 13.3656Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.1ba1e407775e2eff6f18446099f64bd2.svg";
export { ForwardRef as ReactComponent };